import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FirePracticalAssessmentService } from 'src/app/services/fire-practical-assessment-services/fire-practical-assessment.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import * as firebase from 'firebase/app';
import { DataSnapshot } from '@angular/fire/database/interfaces';
import { CommonModule } from '@angular/common';
import * as html2pdf from 'html2pdf.js';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
//Dre Imports for Chart
import { Chart, ChartDataSets, ChartOptions } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';
import { B2Bvalue, B2Cvalue, showQ15to17 } from 'src/app/components/assessment/add-assessment/add-assessment.component';
import { assessmentOperatingApiEndpoint } from 'src/app/consts/conts.global';
import { HttpClient } from '@angular/common/http';
import { filter, first } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'src/app/shared/service/auth.service';


interface ImplementationStatus {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-views-practical',
  templateUrl: './views-practical.component.html',
  styleUrls: ['./views-practical.component.scss'],
})

export class ViewsPracticalComponent implements OnInit {
  probSolvStat: string;
  teamExecutionStat:string;
  industryCondStat:string;

  statResp: ImplementationStatus[] = [
    {value: 'no', viewValue: 'No'},
    {value: 'yes', viewValue: 'Yes'},
  ];

  //implement Read More
  isReadMore = true;
  pendingData = true;
  

  showShortStratDesciption = true
  showShortFinDesciption = true
  showShortLegalDesciption = true
  showShortMarketingDesciption = true
  showShortHiringDesciption = true
  showShortOperationDesciption = true
  showTxtDescription = true
  stratText() {
     this.showShortStratDesciption = !this.showShortStratDesciption
     
  }
  finText() {
    this.showShortFinDesciption = !this.showShortFinDesciption
 }
 legalText() {
  this.showShortLegalDesciption = !this.showShortLegalDesciption
}
marketingText () {
  this.showShortMarketingDesciption = !this.showShortMarketingDesciption
}
hiringText () {
  this.showShortHiringDesciption = !this.showShortHiringDesciption

}
operationsText () {
  this.showShortOperationDesciption = !this.showShortOperationDesciption
}
showTxt() {
  this.showTxtDescription = !this.showTxtDescription;
}
  constructor(
    public firePracticalAssessment: FirePracticalAssessmentService,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private firestoredb: AngularFirestore,
    private guard: AuthGuard,
    private http: HttpClient,
    public authService:AuthService

  ) { }



  //declare form variable here

  data!: any;
  public excellent: string = 'Excellent';
  public good: string = 'Good';
  public average: string = 'Average';
  public belowAverage: string = 'Below Average';
  public poor: string = 'Poor';
  public actionItemForm: FormGroup;

  
  assessmentPayload: any;
  assessmentDate: any;

  @ViewChild('operating') operating: ElementRef;

  ngOnInit(): void {
    this.getAssessmentId();
  }

 
  getAssessmentId() {

    const id = this.actRoute.snapshot.paramMap.get('id');
    this.getAssessmentData(id);
  }
   assessmentInput: any;
 /* getAssessmentData(id: string) {
    //define all variables of a single assessment
    this.http.get(`${assessmentOperatingApiEndpoint}?key=${id}`)
    .pipe(first())
    .subscribe((payload: any) => {
      debugger
      this.assessmentPayload = payload['value']; 
      console.info(this.assessmentPayload?.key); 
      this.assessmentInput = this.firePracticalAssessment.readSustainibleAssessment(`${id}`).get().toPromise().then((snapshot) => {
      this.data = snapshot.data();
      this.showOperating();
      this.pendingData = false;
   //  this.fillActionItemArray();
   //  this.assessmentDate = this.assessmentPayload?.createdAt.toDate();
    });
  });
}*/

getAssessmentData(id: string) {
  //define all variables of a single assessment
  this.firestoredb
    .collection('operating-assessment-results')
    .doc(id)
    .snapshotChanges()
    .pipe(filter((data) => data.payload.exists))
    .subscribe((data: any) => {
      this.assessmentPayload = data.payload.data()?.value;
      this.pendingData = false;
    });
  this.assessmentInput = this.firePracticalAssessment
    .readSustainibleAssessment(`${id}`)
    .get()
    .toPromise()
    .then((snapshot) => {
      this.data = snapshot.data()
    this.showOperating();
    });
}


actionItemArray = [];
notRegisteredAction = ["Register your business"];

fillActionItemArray(){
if (this.data.busiRegType.name === "Not Registered") 
this.actionItemArray.push(this.notRegisteredAction)

}

  goBack() {
    this.location.back();
  }

  exportOnClick() {
    const options = {
      filename: 'Sustainible_Recommendations.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
      margin: 12,
      pagebreak: { mode: 'avoid-all' }
    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  public show: boolean = true;
  public hide: boolean = false;

  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }

  showOperating() {
    
    if (this.data?.practicalCompHistoryExistingCompany?.name == "Yes") {
        this.operating.nativeElement.style.display = 'block';
      }
      else if (this.data?.practicalCompHistoryExistingCompany?.name == "No") {
        this.operating.nativeElement.style.display = 'none';
      }
    }

    step = 0;

    setStep(index: number) {
      this.step = index;
    }
  
    nextStep() {
      this.step++;
    }
  
    prevStep() {
      this.step--;
    }

  }



